/**
 * @fileoverview QuicksearchCategoryTag — minimal Blueprint pill used in
 * the Quicksearch filter row (Apps / Objects / Datasets / Files / …).
 *
 * Foundry mapping: `bp6-button bp6-minimal
 * quicksearch-shared-components__category-tag`.
 */

import { Button } from "@blueprintjs/core";
import type { ReactElement, ReactNode } from "react";

interface QuicksearchCategoryTagProps {
  children: ReactNode;
  active?: boolean;
  onClick?: () => void;
  className?: string;
}

export function QuicksearchCategoryTag({
  children,
  active = false,
  onClick,
  className,
}: QuicksearchCategoryTagProps): ReactElement {
  return (
    <Button data-testid="quicksearch-category-tag"
      minimal
      active={active}
      onClick={onClick}
      className={[
        "bp-quicksearch-category-tag",
        className,
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <span className="bp-quicksearch-category-tag-content">{children}</span>
    </Button>
  );
}
